var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconComment = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 35,
  height: 35,
  rx: 17.5,
  stroke: "#cccccc"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.0082 23.1212H23.7236C24.3007 23.1212 24.7972 22.9108 25.2117 22.4901C25.6256 22.0701 25.8328 21.5754 25.8328 21.0061V11.766C25.8328 11.1973 25.6256 10.702 25.2117 10.2812C24.7972 9.86121 24.3007 9.65018 23.7236 9.65018H12.2757C11.6986 9.65018 11.2028 9.86121 10.7883 10.2812C10.3744 10.702 10.1672 11.1973 10.1672 11.766V25.4222L14.0082 23.1212ZM26.0401 9.46493C26.6798 10.1082 27 10.8879 27 11.8026V20.9688C27 21.8848 26.6798 22.6638 26.0401 23.3064C25.3997 23.9504 24.6278 24.2714 23.7236 24.2714H14.3091L9 27.5V11.8026C9 10.8879 9.31951 10.1082 9.95991 9.46493C10.6003 8.82232 11.3722 8.5 12.2757 8.5H23.7236C24.6278 8.5 25.3997 8.82232 26.0401 9.46493Z",
  fill: "black"
})));
export default SvgIconComment;